import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { id } from "@swimlane/ngx-datatable";
import { ApiConfiguration } from "src/app/services/http/api-configuration";
import { ApiService } from "src/app/services/http/api.service";
import { ToastClientService } from "src/app/services/toast/toast-client.service";

@Component({
  selector: "app-product-edit",
  templateUrl: "./product-edit.component.html",
  styleUrls: ["./product-edit.component.scss"],
})
export class ProductEditComponent implements OnInit {
  public dropdownSettings = {};
  public dropdownList = [];
  public filterdDistributor = [];
  public selectedItems = [];
  public selectedDist = [];
  productImage;
  productCategories: any = [];
  productVarients: any = [];
  productVarientValues: any = [];
  formData: any = {};
  distributor: any = [];
  check: boolean = true;
  distributorMultiselect: any = [];
  id: any;
  imageChanged: boolean = false;

  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private route: Router,
    private activatedRoute: ActivatedRoute,
    private toast: ToastClientService
  ) {
    this.id = activatedRoute.snapshot.paramMap.get("id");
  }

  ngOnInit() {
    this.getProductDetails();
    this.getUsersByRole(18);

    this.formData.is_loyalty = 1;
    this.getAllCategories();
    this.getproductVarient();

    this.dropdownSettings = {
      singleSelection: false,
      idField: "id",
      textField: "text",
      selectAllText: "Select All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
      enableCheckAll: false,
    };
  }

  getProductDetails() {
    this.apiService.get(this.apiConfig.getProductById + this.id).subscribe(
      (res: any) => {
        this.formData = res.data.product_details[0];
        this.formData.product_thumb_image =
          res.data.product_details[0].product_thumb_image;
        this.formData.product_image1 =
          res.data.product_details[0].product_image1;
        this.formData.distributor_list = res.data.distributor_list;
        this.productImage = this.formData.product_thumb_image;
        //selected distributors array
        this.selectedDist = [];
        this.formData.distributor_list.forEach((entry) => {
          this.selectedDist.push(entry.id);
        });
      },
      (err) => {
        this.toast.Error("Unable to get product details");
      }
    );
  }

  toggleCheck() {
    this.check = !this.check;
    console.log(this.check);
  }

  onDistSelect(event) {
    this.selectedItems.forEach((entry) => {
      this.selectedDist.push(entry.id);
    });
  }

  imageChange(img) {
    console.log(img);
    var file = img.target.files[0];
    var reader = new FileReader();
    var self = this;
    reader.onloadend = function () {
      self.productImage = reader.result;
    };
    reader.readAsDataURL(file);
  }

  getAllCategories() {
    this.apiService.get(this.apiConfig.getAllCategiry).subscribe(
      (res: any) => {
        this.productCategories = res.data.ecommerce_categories;
        // console.log(this.productCategories);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getproductVarient() {
    this.apiService.get(this.apiConfig.getProductVarient).subscribe(
      (res: any) => {
        this.productVarients = res.data;
        // console.log(this.productVarients);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getVarientValues(id) {
    this.apiService.get(this.apiConfig.getProductVarientValues + id).subscribe(
      (res: any) => {
        this.productVarientValues = res.data;
        console.log(this.productVarientValues);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  productSave() {
    this.formData.id = parseInt(this.id);

    this.formData.program_id = 1;
    this.formData.product_thumb_image = this.productImage;
    this.formData.product_image1 = this.productImage;

    if (this.imageChanged == true) {
      this.formData.product_thumb_image = this.productImage;
      this.formData.product_image1 = this.productImage;
      this.imageChanged = false;
    } else {
      delete this.formData.product_thumb_image;
      delete this.formData.product_image1;
    }
    this.formData.distributor_list;
    delete this.formData.product_id;
    delete this.formData.product_image2;
    delete this.formData.product_image3;
    delete this.formData.product_image4;
    this.formData.brand_category_id = this.formData.category_id;
    this.formData.distributor_id = this.selectedDist.toString();

    if (this.check == true) {
      this.formData.is_enabled = 1;
    } else {
      this.formData.is_enabled = 0;
    }
    console.log(this.formData);
    // return
    this.apiService
      .post(this.apiConfig.updateProduct, this.formData)
      .subscribe((res) => {
        if (res.status == 200) {
          this.toast.Success("Created Successfully");
          // this.back();
        } else {
          console.log(res);
        }
      });
  }
  back() {
    this.route.navigateByUrl("/hubAdmin/products");
  }

  getUsersByRole(roleId) {
    let postdata = {
      filter_search_geography: [],
      filter_search_channel: [],
      filter_search_region: [],
      filter_search_userrole: [roleId],
    };
    this.apiService.post(this.apiConfig.getUsersFilter, postdata).subscribe(
      (res: any) => {
        this.dropdownList = res.body.data;

        console.log("Contest data is here");

        console.log(this.dropdownList);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  async selectedItem(data) {
    console.log(data);
    let distributors = [];
    this.distributorMultiselect.push(data.data.id);
    this.formData.distributor_id = this.distributorMultiselect.toString();
    console.log(this.formData.distributor_id);
  }
}
